"use client";

import NextImage from "next/image";
import { Image } from "@habacuscode/habacus_ui_component_library";
import habacusBlue from "@/assets/images/logos/habacus_blue.svg";
import { getDateTimeCache } from "@/utils/helpers";
import { useState } from "react";
import { HABACUS_STATIC_URL } from "@/utils/constants";
import { useTranslations } from "next-intl";
import DataSecurityBox from "./DataSecurityBox";

const FOOTER_LINK_KEYS = ["privacy", "transparency", "dataProcessing"] as const;

export default function LeftColumn() {
    const tPrivacy = useTranslations("Privacy");

    const [dateTimeCache] = useState(() => getDateTimeCache("HH"));

    const backgroundUrl = `${HABACUS_STATIC_URL}/background/svg/background_default.svg`;

    return (
        <div className="flex w-full min-h-screen lg:h-screen">
            {/* Main content */}
            <div className="relative flex-1 w-full">
                <NextImage
                    width={640}
                    height={900}
                    src={`${backgroundUrl}?ts=${dateTimeCache}`}
                    alt="Background"
                    className={`absolute inset-0 w-full h-full object-cover `}
                    fetchPriority="high"
                    loading="eager"
                />

                {/* Content container isResultPage */}

                <div
                    className={`mx-auto lg:overflow-y-auto pt-12 md:pt-0 ${true ? "mb-32" : "mb-24"} md:mb-0 gap-8 min-h-screen relative w-full flex flex-col items-center xl:py-16 lg:py-4 lg:gap-4 px-8 place-content-between`}
                >
                    {/* Logo */}
                    <div className="text-navy-900 text-6xl font-bold hidden md:block">
                        <div className="flex justify-left">
                            <Image
                                className="object-contain self-center max-w-[200px] max-h-[100px]"
                                showImageTitle={false}
                                image={`${habacusBlue.src}?ts=${dateTimeCache}`}
                                alt="Habacus"
                                link="#"
                                width={"200px"}
                                height={"100px"}
                            />
                        </div>

                        {/* {wizardConfig.parternship && (
							<>
								<div className={`my-1 w-full text-center text-sm font-bold ${wizardConfig.habacus?.left?.mode == "dark" ? 'text-white' : ''}`}>x</div>
								{retrieveParternshipLogo(wizardConfig.parternship, dateTimeCache)}
							</>
						)} */}
                    </div>

                    {/*{
						appEnv === 'staging' && (
							<StageInfoBoxDisplay language={locale} />
						)
					}*/}

                    {/* {currentStepInfo && (
						<GenericInfoBoxDisplay info={currentStepInfo} language={locale} />
					)} */}

                    <DataSecurityBox />

                    {/* Footer links */}
                    <div className="flex gap-8 mb-3 text-blue-950 font-medium text-xs md:text-sm underline">
                        {FOOTER_LINK_KEYS.map((key) => {
                            const link = tPrivacy.raw(key);
                            return (
                                <a
                                    key={key}
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {link.label}
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
